<template>
  <button
    type="button"
    class="sidenav-toggle"
    @click="toggleSideNav"
  >
    <v-icon icon="$sidebar" :size="16" />
  </button>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useAppSideNav } from '@/stores/app/appSideNav';
import { useFilterDrawer } from '@/stores/filters/filterDrawer';

const { isSideNavOpen } = storeToRefs(useAppSideNav());
const { updateAppSideNavInLocalStorage } = useAppSideNav();

const filterDrawerStore = useFilterDrawer();

const toggleSideNav = () => {
  isSideNavOpen.value = !isSideNavOpen.value;

  // Close the filters if they were open
  if (isSideNavOpen.value && filterDrawerStore.open) {
    filterDrawerStore.open = false;
  }

  updateAppSideNavInLocalStorage(isSideNavOpen.value);
};
</script>

<style lang="less" scoped>
.sidenav-toggle {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  min-width: 30px;
  min-height: 30px;
  border: 1px solid fade(@white, 20%);
  border-radius: 50%;

  :deep(.v-icon) path {
    stroke: @icon-white;
  }

  &:hover {
    background-color: fade(@white, 10%);
    border-color: fade(@white, 70%);
  }
}
</style>
